import { render } from "./MultiArtworkModal.vue?vue&type=template&id=5f0f0c0b&scoped=true"
import script from "./MultiArtworkModal.vue?vue&type=script&lang=js"
export * from "./MultiArtworkModal.vue?vue&type=script&lang=js"

import "./MultiArtworkModal.vue?vue&type=style&index=0&id=5f0f0c0b&scoped=true&lang=scss"
import "./MultiArtworkModal.vue?vue&type=style&index=1&id=5f0f0c0b&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0f0c0b"]])

export default __exports__